<template>
  <div class="sidebar">
    <el-menu
      router
      background-color="rgba(245, 245, 245, 1)"
      class="el-menu-vertical-demo"
      text-color="rgba(51, 51, 51, 1)"
      :default-active="activeMenu"
    >
      <template v-for="lab in menuList">
        <el-sub-menu
          v-if="!lab.hidden && lab.children?.length"
          :index="lab.path"
        >
          <template #title>
            <i :class="['iconfont', lab.meta?.icon]"></i>
            <span>{{ lab.meta?.title }}</span>
          </template>
          <el-menu-item-group>
            <template v-for="item in lab.children">
              <el-menu-item
                :index="lab.path + '/' + item.path"
                v-if="!item.hidden"
                >{{ item.meta?.title }}</el-menu-item
              >
            </template>
          </el-menu-item-group>
        </el-sub-menu>
        <el-menu-item v-else :index="lab.path">{{
          lab.meta?.title
        }}</el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script lang="ts" setup>
import { usePermissionStore } from '@/store/modules/permission'
const permissionStore = usePermissionStore()
const route = useRoute()
const router = useRouter()

const menuList: any = computed(() => permissionStore.getRoutes)
if (!menuList?.length) {
  permissionStore.initRoutesAsync()
}
const activeMenu = computed(() => route.path) //window.location.pathname
watch(
  () => permissionStore.getRoutes,
  (newVal: any) => {
    let hasRouteAuth = false
    const checkCurRoute = (routes: any) => {
      routes?.forEach((r: any) => {
        if (r.name === route.name) {
          hasRouteAuth = true
          return
        } else if (r.children) {
          checkCurRoute(r.children)
        }
      })
    }
    checkCurRoute(newVal)
    if (!hasRouteAuth) {
      router.push({ path: newVal.at(0)?.path })
    }
  }
)
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
.sidebar {
  height: 100%;
  overflow: auto;
  scrollbar-width: none; /* firefox */
  -ms-overflow-style: none; /* IE 10+ */
  overflow-x: hidden;
  :deep(.el-menu-item-group__title) {
    padding: 0;
  }
  :deep(.el-col-12) {
    min-width: 100%;
    height: 100%;
  }
  :deep(.el-menu) {
    border: none;
  }
  .iconfont {
    font-size: 18px;
    margin-right: 5px;
  }
}
</style>
